<template>
  <!-- 年度营销规划 -->
  <div class="annual-plan-page ">
    <!-- 筛选模块 -->
    <div class="filter-container common_contentBox">
      <el-form :model="filters" label-width="120px" label-color="#424C57" class="common_search">
        <el-row>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
            <el-form-item label="年份：">
              <el-select v-model="filters.year" placeholder="请选择年份" clearable :disabled="loading">
                <el-option v-for="y in years" :key="y.value" :label="y.label" :value="y.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
            <el-form-item label="类型：">
              <el-select v-model="filters.type" placeholder="请选择类型" clearable :disabled="loading" @change="handleTypeChange">
                <el-option v-for="opt in typeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="filters.type" :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
            <el-form-item :label="filters.type === 'REGION' ? '区域：' : '行业：'" prop="departmentId">
              <el-select v-model="filters.departmentId" :placeholder="filters.type === 'REGION' ? '请选择区域' : '请选择行业'" clearable :disabled="loading">
                <el-option v-for="opt in commonList" :key="opt.value" :label="opt.label" :value="opt.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
            <el-form-item label="提交人：">
              <el-input v-model.trim="filters.submitUser" placeholder="请输入提交人" clearable :disabled="loading" />
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
            <el-form-item label="审批状态：">
              <el-select v-model="filters.status" placeholder="请选择审批状态" clearable :disabled="loading">
                <el-option v-for="st in approvalStatusOptions" :key="st.value" :label="st.label" :value="st.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="filters.type ? 18 : 24" :xl="filters.type ? 18 : 24">
            <div class="filter-actions">
              <el-button :disabled="loading" @click="onReset" class="reset-btn">重置</el-button>
              <el-button type="primary" :loading="loading" :disabled="loading" @click="onSearch">搜索</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="btn-list">
      <el-button type="primary" @click="addAnnualPlan">提报年度规划</el-button>
      <el-button type="primary" @click="exportAnnualPlan">导出</el-button>
    </div>
    <!-- 列表模块 -->
    <div class="list-container">
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        class="annual-table"
        :header-cell-style="{ color: '#424C57' }"
        :cell-style="{ color: '#424C57' }"
      >
        <!-- 基础列 -->
        <el-table-column prop="year" label="年份" min-width="90" />
        <el-table-column prop="planName" label="类型" min-width="90">
          <template #default="{row}">
            {{ typeVal(row.type) || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="departmentName" label="区域/行业" min-width="160" />
        <!-- Q1 ~ Q4 分组表头占位：当该季度有子列时显示组 -->
        <el-table-column label="Q1">
          <el-table-column prop="quarters.q1.statusDesc" label="状态" min-width="90">
            <template #default="{row}">
              <span v-if="quarterStatus(row.quarters.q1.status)" @click="handleQuarterStatusClick(row, 'q1')" class="status-label">{{ row.quarters.q1.statusDesc || '--' }}</span>
              <span v-else>{{ row.quarters.q1.statusDesc || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quarters.q1.target" label="操作" min-width="90">
            <template #default="{row}">
              <div v-if="isOperate(row, 'q1')">
                <el-button v-if="isQuarterEditable(row, 'q1')" type="text" @click="applyFiling(row, 'q1')">{{ row.quarters.q1.status === 1 ? '填报' : '编辑' }}</el-button>
                <el-button v-else-if="isQuarterViewable(row, 'q1')" type="text" @click="viewFilingDetails(row, 'q1')">{{ isQuarterBtnText(row, 'q1') ? '审批' : '查看' }}</el-button>
                <div v-else>--</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Q2">
          <el-table-column prop="quarters.q2.statusDesc" label="状态" min-width="90">
            <template #default="{row}">
              <span v-if="quarterStatus(row.quarters.q2.status)" @click="handleQuarterStatusClick(row, 'q2')" class="status-label">{{ row.quarters.q2.statusDesc || '--' }}</span>
              <span v-else>{{ row.quarters.q2.statusDesc || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quarters.q2.target" label="操作" min-width="90">
            <template #default="{row}">
              <div v-if="isOperate(row, 'q2')">
                <el-button v-if="isQuarterEditable(row, 'q2')" type="text" @click="applyFiling(row, 'q2')">{{ row.quarters.q2.status === 1 ? '填报' : '编辑' }}</el-button>
                <el-button v-else-if="isQuarterViewable(row, 'q2')" type="text" @click="viewFilingDetails(row, 'q2')">{{ isQuarterBtnText(row, 'q2') ? '审批' : '查看' }}</el-button>
                <div v-else>--</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Q3">
          <el-table-column prop="quarters.q3.statusDesc" label="状态" min-width="90">
            <template #default="{row}">
              <span v-if="quarterStatus(row.quarters.q3.status)" @click="handleQuarterStatusClick(row, 'q3')" class="status-label">{{ row.quarters.q3.statusDesc || '--' }}</span>
              <span v-else>{{ row.quarters.q3.statusDesc || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quarters.q3.target" label="操作" min-width="90">
            <template #default="{row}">
              <div v-if="isOperate(row, 'q3')">
                <el-button v-if="isQuarterEditable(row, 'q3')" type="text" @click="applyFiling(row, 'q3')">{{ row.quarters.q3.status === 1 ? '填报' : '编辑' }}</el-button>
                <el-button v-else-if="isQuarterViewable(row, 'q3')" type="text" @click="viewFilingDetails(row, 'q3')">{{ isQuarterBtnText(row, 'q3') ? '审批' : '查看' }}</el-button>
                <div v-else>--</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="Q4">
          <el-table-column prop="quarters.q4.statusDesc" label="状态" min-width="90">
            <template #default="{row}">
              <span v-if="quarterStatus(row.quarters.q4.status)" @click="handleQuarterStatusClick(row, 'q4')" class="status-label">{{ row.quarters.q4.statusDesc || '--' }}</span>
              <span v-else>{{ row.quarters.q4.statusDesc || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="quarters.q4.target" label="操作" min-width="90">
            <template #default="{row}">
              <div v-if="isOperate(row, 'q4')">
                <el-button v-if="isQuarterEditable(row, 'q4')" type="text" @click="applyFiling(row, 'q4')">{{ row.quarters.q4.status === 1 ? '填报' : '编辑' }}</el-button>
                <el-button v-else-if="isQuarterViewable(row, 'q4')" type="text" @click="viewFilingDetails(row, 'q4')"> {{ isQuarterBtnText(row, 'q4') ? '审批' : '查看' }}</el-button>
                <div v-else>--</div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="submitUserName" label="提交人" min-width="120" />
        <el-table-column prop="submitTime" label="申请时间" min-width="160" />
        <el-table-column prop="statusDesc" label="审批状态" min-width="120">
          <template #default="{row}">
            <span class="status-label" @click="handleStatusClick(row)">{{ row.statusDesc || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="approvalStatusLabel" label="年度目标查看" min-width="120">
          <template #default="{row}">
            <div class="operate-btn">
              <el-button type="text" @click="handleView(row)">{{ operateStatus(row.status) && isCurrentUser(row) ? '编辑' : isAnnualBtnText(row) }}</el-button>
              <span v-if="row.changeButtonVisible && isCurrentUser(row)" class="btn-split">|</span>
              <el-button v-if="row.changeButtonVisible && isCurrentUser(row)" type="text" @click="handleEdit(row)">修改</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-container" v-if="!loading">
        <el-pagination
          background
          layout="slot, prev, pager, next, jumper, sizes"
          :current-page="pagination.page"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="pagination.size"
          :total="pagination.total"
          @current-change="onPageChange"
          @size-change="onSizeChange"
        >
          <template #default>
            <span class="table-total">共 {{ pagination.total || 0 }} 条记录</span>
          </template>
        </el-pagination>
      </div>
    </div>
    <approveList ref="approveList" />
  </div>
</template>

<script>
import { annualApplicationApi } from './service';
import { newApplicationFormApi } from '../newApplicationForm/service/index';
import { APPROVAL_STATUS_OPTIONS, QUARTER_PERIODS } from '@/utils/constants';
import approveList from './components/approveList.vue';
export default {
  name: 'AnnualMarketingPlan',
  components: {
    approveList
  },
  data () {
    return {
      loading: false,
      filters: {
        year: undefined,
        type: undefined,
        submitUser: undefined,
        status: undefined
      },
      typeOptions: [
        { label: '区域', value: 'REGION' },
        { label: '行业', value: 'INDUSTRY' }
      ],
      approvalStatusOptions: APPROVAL_STATUS_OPTIONS,
      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      quarterVisible: {
        q1: true,
        q2: true,
        q3: true,
        q4: true
      },
      commonList: [],
      areaList: [],
      industryList: [],
      searchParams: {},
      years: [] // 已有年度列表
    };
  },
  computed: {
    // 是否可操作
    isOperate () {
      return (row, quarter) => {
        // 以当前行的年份计算每个季度开放填报的起始日期
        const openDates = {
          q1: { month: 3, day: 1 },
          q2: { month: 6, day: 1 },
          q3: { month: 9, day: 8 },
          q4: { month: 11, day: 20 }
        };
        const config = openDates[quarter];
        if (!config) {
          return false;
        }
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        const currentYear = now.getFullYear();
        let isTimeOpen = row.year < currentYear;
        if (!isTimeOpen) {
          const openDate = new Date(row.year, config.month, config.day);
          openDate.setHours(0, 0, 0, 0);
          isTimeOpen = now >= openDate;
        }
        // 0-未开始 1-待完成 2-审批中
        // 时间到达开放日期 && 该季度状态不为未开始 && 整体状态已完成，才允许操作
        const statusList = [2, 6, 7, 8]; // 可操作状态
        return isTimeOpen && row[quarter].status !== 0 && statusList.includes(row.status);
      };
    },
    // 当前用户判断
    isCurrentUser () {
      return (row) => {
        const submitUserName = row.submitUserName;
        const currentUserName = this.$store.state.userInfo.sysUser.userName;
        return submitUserName === currentUserName;
      };
    },
    typeVal () {
      return (type) => {
        return this.typeOptions.find(item => item.value === type)?.label;
      };
    },
    // 年度规划查看/编辑
    operateStatus () {
      return (status) => {
        // 1-审批中 2-已完成 3-驳回 4-召回 5-废弃
        const statusList = [3, 4]; // 可操作状态
        return statusList.includes(status);
      };
    },
    // 季度状态判断：0 未开始 1 待完成
    quarterStatus () {
      return (status) => {
        const statusList = [0, 1]; // 不可操作状态
        return !statusList.includes(status);
      };
    },
    // 季度查看/填报：1-待完成 4-驳回 5-召回
    isQuarterEditable () {
      return (row, quarter) => {
        const statusList = [1, 4, 5]; // 可操作状态
        const rowStatusList = [6]; // 整体状态不可操作
        const submitUserName = row.submitUserName;
        const currentUserName = this.$store.state.userInfo.sysUser.userName;
        return statusList.includes(row.quarters[quarter].status) && submitUserName === currentUserName && !rowStatusList.includes(row.status);
      };
    },
    // 季度查看
    isQuarterViewable () {
      return (row, quarter) => {
        const statusList = [0, 1]; // 可操作状态
        return !statusList.includes(row.quarters[quarter].status);
      };
    },
    // 年度按钮文本判断：审批/查看
    isAnnualBtnText () {
      return (row) => {
        // 年度审批状态为审批中 && row权限类型为1
        return row.status === 1 && row.permissionType === 1 ? '审批' : '查看';
      };
    },
    // 季度按钮文本判断：审批/查看
    isQuarterBtnText () {
      return (row, quarter) => {
        // 季度审批状态为审批中 && row权限类型为1
        return row.quarters[quarter].status === 2 && row.permissionType === 1;
      };
    },
    // 季度审批是否完成
    isQuarterUnfinished () {
      return (row) => {
        // 获取季度状态数组
        const quarterStatus = QUARTER_PERIODS.map(item => row[item.key].status);
        const statusList = [1, 4, 5]; // 未完成状态 1-待完成 4-驳回 5-召回
        return quarterStatus.some(status => statusList.includes(status)); // 存在未完成状态的季度，则返回 true
      };
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.getAnnualPlanList();
      this.getIndustryList();
      this.getAreaList();
      this.getCurrentYears();
    },
    // 获取当前年度列表
    getCurrentYears () {
      annualApplicationApi.getYears().then(res => {
        if (res.status === '200') {
          this.years = res.data.map(item => {
            return {
              label: item,
              value: item
            };
          });
        }
      });
    },
    // 导出年度规划
    exportAnnualPlan () {
      const params = {
        ...this.searchParams
      };
      annualApplicationApi.annualPlanExport(params).then(res => {
        // 因为导出 API 返回二进制流，我们在 service 层将会返回完整的 response（res 是 axios response）
        // res.data: ArrayBuffer, res.headers: headers
        try {
          const arrayBuffer = res.data;
          const contentDisposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
          let fileName = '年度营销规划.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i);
            if (fileNameMatch) {
              fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
            }
          }
          const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
            return;
          }
          const link = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
        } catch (e) {
          this.$message.error('导出失败');
        }
      }).catch(() => {
        this.$message.error('导出失败');
      });
    },
    // 类型变化
    handleTypeChange (val) {
      this.$set(this.filters, 'departmentId', undefined);
      if (val === 'REGION') {
        this.commonList = this.areaList;
      } else if (val === 'INDUSTRY') {
        this.commonList = this.industryList;
      } else {
        this.commonList = [];
      }
      this.$emit('typeChange', val);
    },
    // 新增年度规划
    addAnnualPlan () {
      this.$router.push({
        path: '/annualPlanApplication'
      });
    },
    // 搜索
    onSearch () {
      this.loading = true;
      this.pagination.page = 1;
      const params = {
        ...this.filters
      };
      this.searchParams = params;
      this.getAnnualPlanList(params);
    },
    // 获取区域列表
    getAreaList () {
      newApplicationFormApi.getRegionName().then(res => {
        if (res.status === '200') {
          const data = JSON.parse(JSON.stringify(res.data));
          this.areaList = data.map(item => {
            return {
              label: item.value,
              value: item.key
            };
          });
        }
      });
    },
    // 获取行业列表
    getIndustryList () {
      newApplicationFormApi.getActivityList(['annual_industry']).then(res => {
        if (res.status === '200') {
          const data = JSON.parse(JSON.stringify(res.data));

          this.industryList = data.annual_industry.map(item => {
            return {
              label: item.fieldValue,
              value: item.fieldValue2
            };
          });
        }
      });
    },
    // 获取年度规划列表
    getAnnualPlanList () {
      this.loading = true;
      const params = {
        ...this.searchParams,
        pageNo: this.pagination.page,
        pageSize: this.pagination.size
      };
      annualApplicationApi.annualPlanList(params).then(res => {
        if (res.status === '200') {
          const result = JSON.parse(JSON.stringify(res.data));
          result.list.forEach(item => {
            // 处理季度数据为空的情况
            item.quarters = {};
            ['q1', 'q2', 'q3', 'q4'].forEach(q => {
              if (!item.quarters[q]) {
                item.quarters[q] = item[q];
              }
            });
          });
          this.tableData = result.list;
          this.pagination.total = result.total;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    // 重置
    onReset () {
      this.filters = { year: undefined, type: undefined, departmentId: undefined, submitUser: undefined, status: undefined };
      this.pagination.page = 1;
      this.pagination.size = 10;
      this.searchParams = {};
      this.getAnnualPlanList();
    },
    // 分页
    onPageChange (page) {
      this.pagination.page = page;
      this.getAnnualPlanList();
    },
    // 每页条数变化
    onSizeChange (size) {
      this.pagination.size = size;
      this.getAnnualPlanList();
    },
    // 查看/修改年度规划详情
    handleView (row) {
      const statusList = [3, 4]; // 可操作状态
      const routerUrl = statusList.includes(row.status) ? '/annualPlanApplication' : '/annualPlanDetails';
      this.$router.push({
        path: routerUrl,
        query: {
          id: row.id
        }
      });
    },
    // 年度规划审批完成-编辑年度规划
    handleEdit (row) {
      this.$router.push({
        path: '/annualPlanApplication',
        query: {
          id: row.id,
          isCompletedEdit: 2
        }
      });
    },
    // 申请季度填报
    applyFiling (row, quarter) {
      this.$router.push({
        path: '/quarterlyFilingApplication',
        query: {
          year: row.year,
          quarter: quarter,
          annualPlanId: row.id,
          id: row[quarter].quarterReportId
        }
      });
    },
    // 查看季度填报详情
    viewFilingDetails (row, quarter) {
      this.$router.push({
        path: '/quarterlyFilingDetails',
        query: {
          year: row.year,
          quarter: quarter,
          annualPlanId: row.id,
          id: row[quarter].quarterReportId
        }
      });
    },
    // 查看年度审批状态
    handleStatusClick (row) {
      this.$refs.approveList.init({
        dialogVisible: true,
        id: row.id
      });
    },
    // 查看季度审批状态
    handleQuarterStatusClick (row, quarter) {
      this.$refs.approveList.init({
        dialogVisible: true,
        id: row[quarter].quarterReportId
      });
    }
  },
  activated () {
    this.init();
  }
};
</script>
<style lang="scss">
.filter-container{
  .el-form-item .el-form-item__label{
    color: #424C57;
  }
}
.annual-table{
  border-color: #e2e4e9; // #e2e4e9
  thead.is-group th.el-table__cell{
    background: #f6f7f9;
    border-color: #e2e4e9;
    color: #424C57;
    font-weight: normal;
  }
  tbody td.el-table__cell{
    border-color: #e2e4e9;
    padding: 7.5px 0;
    color: #424C57;
  }
  th.el-table__cell.is-leaf{
    border-color: #e2e4e9 ;
  }
  .el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-color: #e2e4e9;
  }
  .el-table__body-wrapper {
    &::-webkit-scrollbar {
      height: 8px;
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: rgba(144, 147, 153, 0.3);
    }
    &::-webkit-scrollbar-thumb:hover {
      background: rgba(144, 147, 153, 0.5);
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #ffffff;
    }
  }
  .el-loading-mask{
    background: rgba(0, 0, 0, 0.2) !important;
    .circular{
      display: none;
    }
    .el-loading-spinner{
      width: 50px;
      height: 50px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-top: 0;
      &:before,
      &:after {
        content: "";
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #14937b;
        opacity: 0.6;
        position: absolute;
        top: 0;
        left: 0;
        animation: bounce 2.0s infinite ease-in-out;
      }
      &:after {
        animation-delay: -1.0s;
      }
    }
    @keyframes bounce {
      0%, 100% {
        transform: scale(0);
      } 50% {
        transform: scale(1);
      }
    }
  }
}
.pager-container{
  .el-pagination{
    padding-right: 0;
  }
  .el-pagination__jump{
    margin-left: 5px;
  }
  .el-pagination__sizes {
    margin-right: 0;
    .el-select{
      line-height: 28px;
      .el-input{
        height: 28px;
      }
    }
  }
  .el-pager{
    .number{
      color: #424c58;
      background-color: #f6f7f9;
      border: 1px solid #d7d8da;
      font-weight: normal;
      border-radius: 4px !important;
    }
    .number:hover{
      color: #424c58 !important;
      border-color: #17A58A;
    }
    .active{
      border-color: #17A58A;
      color: #fff;
      font-weight: bold;
    }
    .active:hover{
      color: #fff !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.filter-container {
  margin-bottom: 12px;
}
.filter-form .el-form-item {
  margin-right: 16px;
  margin-bottom: 8px;
}
.filter-actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
  margin-bottom: 16px;
}
.btn-list{
  margin-bottom: 16px;
}
.annual-table {
  width: 100%;
}
.pager-container {
  padding: 12px 0;
  display: flex;
  justify-content: flex-end;
}
.table-total {
  font-size: 13px;
  font-weight: 400;
  color: #606266;
}
.el-form-item{
  width: 100%;
  margin-bottom: 0;
  .el-select{
    width: 100%;
  }
}
.reset-btn{
  border: 1px solid #C6C7C7;
  background: #F6F7F9;
  color: #202932;
}
.status-label{
  color: #508DB4;
  cursor: pointer;
}
.operate-btn{
  .el-button--text{
    padding: 0 !important;
    min-width: max-content;
  }
  .btn-split{
    color:#508DB4;
    font-size: 14px;
    margin: 0 2px;
  }
}
</style>
